import { ColumnOption } from "../../../constants/schema.js";
import { changeColumnNameAction, changeColumnNameDerivedAction } from "../table-column/atom.actions.js";
import { normalizeDictionaryName } from "./dictionaryIndex.js";
import { bHas } from "../../../utils/bit.js";
import { changeTableNameAction, changeTableNameDerivedAction } from "../table/atom.actions.js";
import { toNameKey } from "../relationship/fkColumns.js";
import { derivePhysical } from "./derive.js";
//#region src/engine/modules/dictionary/derivedNames.ts
function toNameWrites(state, name, derived, logicalName, force) {
	const hasLogicalName = normalizeDictionaryName(logicalName) !== "";
	if (force ? !hasLogicalName : name.trim() !== "" && !derived) return null;
	const physical = derivePhysical(state, logicalName);
	const physicalName = physical?.physicalName || null;
	return {
		name: physicalName !== null && physicalName !== name ? physicalName : null,
		flag: !derived && (force || physicalName !== null),
		domainId: physical?.domainId ?? ""
	};
}
function namesOfTable(state, ledger, tableId) {
	let names = ledger.get(tableId);
	if (!names) {
		const { tableEntities, tableColumnEntities } = state.collections;
		names = /* @__PURE__ */ new Map();
		for (const id of tableEntities[tableId]?.columnIds ?? []) {
			const column = tableColumnEntities[id];
			if (column) names.set(id, toNameKey(column.name));
		}
		ledger.set(tableId, names);
	}
	return names;
}
function isNameTaken(names, columnId, key) {
	for (const [id, held] of names) if (id !== columnId && held === key) return true;
	return false;
}
function toColumnNameWrites(state, tableId, column, logicalName, force = false, ledger = /* @__PURE__ */ new Map()) {
	const writes = toNameWrites(state, column.name, bHas(column.options, ColumnOption.nameDerived), logicalName, force);
	if (!writes) return {
		actions: [],
		link: null
	};
	if (writes.name !== null) {
		const names = namesOfTable(state, ledger, tableId);
		const key = toNameKey(writes.name);
		if (isNameTaken(names, column.id, key)) return {
			actions: [],
			link: null
		};
		names.set(column.id, key);
	}
	const target = {
		tableId,
		id: column.id
	};
	const actions = [];
	if (writes.name !== null) actions.push(changeColumnNameAction({
		...target,
		value: writes.name
	}));
	if (writes.flag) actions.push(changeColumnNameDerivedAction({
		...target,
		value: true
	}));
	return {
		actions,
		link: writes.domainId ? {
			...target,
			value: writes.domainId
		} : null
	};
}
function toTableNameWrites(state, table, logicalName, force = false) {
	const writes = toNameWrites(state, table.name, table.nameDerived, logicalName, force);
	if (!writes) return [];
	const actions = [];
	if (writes.name !== null) actions.push(changeTableNameAction({
		id: table.id,
		value: writes.name
	}));
	if (writes.flag) actions.push(changeTableNameDerivedAction({
		id: table.id,
		value: true
	}));
	return actions;
}
//#endregion
export { toColumnNameWrites, toTableNameWrites };
